export default "__VITE_ASSET__DZvrHOkz__"